/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetManyUsersResponse extends IMessage {
	users: Record<string, unknown>[];
}

export default class GetManyUsersResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'GetManyUsersResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			users: {
				rule: 'repeated',
				type: 'UserDescriptor',
				id: 1
			}
		}
	};

	public constructor( public readonly users: Record<string, unknown>[] ) {
		super();
	}

	public toJSON(): IGetManyUsersResponse {
		return {
			users: this.users.map( _userToJson )
		};
	}

	public static fromJSON( data: IGetManyUsersResponse ): GetManyUsersResponse {
		return new GetManyUsersResponse( data.users.map( _userFromJson ) );
	}
}

function _userToJson( user: Record<string, unknown> ): { attributes: Record<string, string>[]; } {
	return {
		attributes: Object.keys( user ).map( key => ( { key, value: JSON.stringify( user[ key ] ) } ) )
	};
}

function _userFromJson( data: { attributes: Record<string, string>[]; } ): Record<string, unknown> {
	return data.attributes.reduce(
		( result, keyValue ) => {
			result[ keyValue.key ] = keyValue.value ? JSON.parse( keyValue.value ) : null;

			return result;
		},
		{}
	);
}
